import { BarControllerChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";
import { createStylesheet } from "../../../_app/utils/styles";
import { Query } from "../../../filter/types";
import { useDataUser } from "../../hooks";
import GraphWidget from "./GraphWidget";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      labels: {
        filter: () => {},
      },
      title: {
        text: "Number and users",
        display: true,
      },
    },
    title: {
      display: false,
    },
    tooltip: {
      position: "nearest",
      backgroundColor: "#ffffff",
      titleColor: "#000000",
      bodyColor: "#000000",
      displayColors: false,
      padding: 15,
      borderColor: "#000000",
      caretSize: 0,
      borderWidth: 1,
      callbacks: {
        label: function (context: any) {
          let label = context?.dataset?.label || "Total Data Usage";
          if (context.parsed.y !== null) {
            label += context.parsed.y;
          }
          return label;
        },
        title: function (context: any) {
          const title = context?.[0]?.raw?.name;
          const number = context?.[0]?.raw?.number;

          return ["Name: " + title, "Number: " + number];
        },
      },
    },
  },
  parsing: {
    xAxisKey: "label",
    yAxisKey: "values.data",
  },
  skipNull: true,
  interaction: {
    mode: "point",
  },
  scales: {
    x: {
      ticks: {
        display: false,
      },
    },
  },
} as BarControllerChartOptions;

interface Props {
  queries: Query[];
}

const TopDataUser = ({ queries }: Props) => {
  const classes = useStyles();
  const { data = [], isFetching, isError } = useDataUser(queries);
  const hasError = isError || data?.length <= 0;

  return (
    <GraphWidget title="Top 10 Data Users (GBs)" isLoading={isFetching} hasError={hasError}>
      <div className={classes.horizontalBarWrap}>
        <Bar data={data} options={options} />
      </div>
    </GraphWidget>
  );
};

const useStyles = createStylesheet(() => ({
  horizontalBarWrap: {
    position: "relative",
    minHeight: 410,
    width: "100%",
  },
}));

export default TopDataUser;
